export default "__VITE_ASSET__DUcbMQpT__"